import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import promisify from 'util.promisify';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18n from '../i18n';
import { ROUTE_HOME } from '../routes/constants';
import userSlice from '../collections/user';
import isAuthEnabled from '../helpers/authHelpers';

class LogoutView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedOut: false,
    };
  }

  componentDidMount = () => {
    if (isAuthEnabled()) {
      this.logout();
    } else {
      this.setState({ loggedOut: true });
    }
  };

  logout() {
    const { logout } = this.props;
    return promisify(window.ssense.logout.bind(window.ssense))().then(() => {
      this.setState({loggedOut: true})
      logout();
    }).catch((e) => {
      console.error(e)
    })
  }

  render() {
    const { loggedOut } = this.state;
    if(loggedOut){
      return (
        <Redirect to={{ pathname: ROUTE_HOME }} />
      );
    }
    return (
      <div>
        {i18n.t('logout')}
        ...
      </div>
    );
    
  }
}

LogoutView.propTypes = {
  logout: PropTypes.func.isRequired
};

const mapDispatchToProps = { logout: userSlice.actions.logout };

export { LogoutView as LogoutViewNoConnect };
export default connect(null, mapDispatchToProps)(LogoutView);
